/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Icon,
  Text,
  Space,
} from '@cashfree-intl/coherent';
import CustomIcon from 'components/CustomIcons';
import {
  BLOCK,
  BLOCKED,
  BLOCK_VENDOR,
  DELETE,
  UNBLOCK_VENDOR,
  manageVendorOptions,
} from '../constants';

export function ManageVendorDropdown({ vendorIdData, onManageVendorClick }) {
  return (
    <Dropdown
      icon={null}
      trigger={
        <Button secondary>
          Manage Vendor
          <span className="ml-1">
            <Icon name="chevron-down" />
          </span>
        </Button>
      }
    >
      <DropdownMenu>
        {manageVendorOptions.map(option => {
          manageVendorOptions[0].text =
            vendorIdData?.status === BLOCKED ? UNBLOCK_VENDOR : BLOCK_VENDOR;
          return (
            <DropdownItem
              key={option.key}
              onClick={() => onManageVendorClick(option)}
              data-event-name="Dropdown_Item"
              data-ignore-inner-text="true"
              data-event-properties={JSON.stringify({
                dropdown_id: option.value,
              })}
            >
              <Space direction="column">
                <Space gap={1}>
                  {option.value === DELETE && <Icon name={option.icon} />}
                  {option.value === BLOCK && (
                    <CustomIcon componentName="BLOCK" />
                  )}
                  <Text color={option.value === BLOCK ? 'bodyLight' : 'danger'}>
                    {option.text}
                  </Text>
                </Space>
              </Space>
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
}

ManageVendorDropdown.propTypes = {
  vendorIdData: PropTypes.number.isRequired,
  onManageVendorClick: PropTypes.func.isRequired,
};

export default ManageVendorDropdown;
